@if (src) {
  <img [src]="src" [class]="className" />
}
